import http from './reddit'

export default {
  list: (type = '1', date, page = '1000') => http.Get(`${http.url.Newcommon}/tralogltfu/${type}/${date}/${page}`),     //操盘纪录_列表
  select: () => http.Get(`${http.url.Newcommon}/daybaup`),     //操盘纪录_选单日期
}